import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDAlert,
  FDList,
  FDListItem,
  FDListItemSecondary,
  FDListItemText,
  FDStack,
  FDSecondaryActionIconButton, FDPrimaryActionIconButton, FDPrimaryActionButton, FDTextButton,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { dataAttrs } from 'Helpers/Testing';
import metaOverrideSet from '../metaOverrideSet';

const Layout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();

  const handleAddOrEditMatch = async (rel) => {
    await loadModalCollectionByLink(rel.link('related').url());
  };

  const disabledNoMatch = !(resource.isTruthy('hasMatch') || resource.isTruthy('confirmNoMatch'));

  return (
    <>
      <MetaControlField attr={'title'} resource={resource} metaOverrideSet={metaOverrideSet} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" spacing={3}>
          <MetaControlField attr={'subtitle'} resource={resource} metaOverrideSet={metaOverrideSet} />
          <MetaControlField attr="description" />
          {resource.attr('infoMessage') ? (
            <FDAlert status="info" description={resource.attr('infoMessage')} />
          ) : null}
          <FDStack direction="column" spacing={1} alignItems="center">
            <FDList variant="separated">
              {resource.withRelationship(fr.relationships.subStep.name, (rel) => (
                <FDListItem
                  onClick={() => {
                    return handleAddOrEditMatch(rel);
                  }}
                >
                  <FDListItemText
                    primaryText={resource.attr('primaryText')}
                    secondaryText={resource.attr('secondaryText')}
                  />
                  <FDListItemSecondary>
                    <FDSecondaryActionIconButton icon={rel.meta('icon')} />
                  </FDListItemSecondary>
                </FDListItem>
              ), () => null)}
            </FDList>
            {resource.isTruthy('hasMatch') ? (
              <div>
                <FDTextButton
                  disabled={saving}
                  label={'Delete this contribution'}
                  onClick={() => {
                    resource.attr('confirmNoMatch', 'true');
                    onSubmit();
                  }}
                />
              </div>
            ) : (
              <MetaControlField attr="confirmNoMatch" metaOverrideSet={metaOverrideSet} />
            )}
          </FDStack>
        </FDStack>
      </DialogContent>
      <DialogActions>
        {resource.withRelationship(fr.relationships.previousLink.name,
          (rel) => (
            <FDPrimaryActionIconButton
              icon="chevronLeft"
              onClick={() => {
                loadModalCollectionByLink(rel.link('related').url());
              }}
            />
          ),
          () => null)}
        {resource.meta().canPost() ? (
          <FDPrimaryActionButton
            {...dataAttrs('continue-btn', resource)}
            label={'Continue'}
            onClick={onSubmit}
            disabled={saving || disabledNoMatch}
          />
        ) : null}
      </DialogActions>
    </>
  );
};

export default Layout;
